/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { selectPrintMode } from '../../../store';
import Scrollbars from './Scrollbars';

const EXPORT_WIDTH = 1100;

const PRINT_STYLE = {
  width: `${EXPORT_WIDTH}px`,
  overflow: 'unset',
  margin: '0 auto',
};

const NORMAL_STYLE = {
  height: '100%',
  width: '100%',
  overflow: 'hidden',
};

const PRINT_VIEW_STYLES = {
  position: 'static',
  top: 'auto',
  left: 'auto',
  right: 'auto',
  bottom: 'auto',
  overflow: 'unset',
  marginBottom: 0,
};

const ScrollbarsPrintModeWrapper = (props: any) => {
  const { children } = props;
  const printMode = useSelector(selectPrintMode, shallowEqual);
  return (
    <Scrollbars
      style={printMode ? PRINT_STYLE : NORMAL_STYLE}
      hideTracksWhenNotNeeded={false}
      verticalThumbAlwaysHidden={printMode}
      renderView={({ style, ...props }: any) => {
        const customStyle = printMode ? PRINT_VIEW_STYLES : {};
        return <div {...props} style={{ ...style, ...customStyle }} />;
      }}
    >
      {children}
    </Scrollbars>
  );
};

export default ScrollbarsPrintModeWrapper;
